import {
    Box,
    Button,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure
} from "@chakra-ui/react";
import React from "react";
import { MdAdd, MdSettings } from "react-icons/md";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { AdminSignupForm, IAdminSignupFormValues } from "../../forms";
import {
    AccountRole,
    AccountStatus,
    AccountsDocument,
    useAccountsQuery,
    useCreateAuthorMutation,
    useDeleteAuthorMutation
} from "../../graphql";
import { formatDateTime } from "../../utils";

const Authors: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const accountQueryVariables = {
        role: AccountRole.Author,
        accountStatus: AccountStatus.Active,
        page: 1,
        pageLimit: 1000
    };

    const { data, loading } = useAccountsQuery({
        variables: accountQueryVariables
    });

    const [signup] = useCreateAuthorMutation();
    const [remove] = useDeleteAuthorMutation();

    const handleSignup = async (client: IAdminSignupFormValues) => {
        await signup({
            variables: {
                email: client.email,
                lastname: client.lastname,
                name: client.name
            },
            refetchQueries: [
                {
                    query: AccountsDocument,
                    variables: accountQueryVariables
                }
            ]
        });

        onClose();
    };

    const handleDeleteEvent = async (id: number) => {
        await remove({
            variables: {
                id: id
            },
            refetchQueries: [
                {
                    query: AccountsDocument,
                    variables: accountQueryVariables
                }
            ]
        });
    };

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Shto një autor</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AdminSignupForm onSubmit={ (user) => handleSignup(user) } />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <>
                { loading ? (
                    <Loader />
                ) : (
                    <Box
                        borderWidth="1px"
                        borderRadius="lg"
                        overflow="hidden"
                        p={ 2 }
                        background="white"
                    >
                        <Title title="Lista e autorëve">
                            <Button
                                colorScheme="blue"
                                size="sm"
                                variant="ghost"
                                leftIcon={ <MdAdd /> }
                                onClick={ onOpen }
                            >
                                Shto autor
                            </Button>
                        </Title>

                        <Table variant="striped" size="sm">
                            <Thead>
                                <Tr>
                                    <Th>Emri</Th>
                                    <Th>E-mail</Th>
                                    <Th isNumeric>Data e rregjistrimit</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                { data?.accounts?.nodes.map((account) => (
                                    <Tr key={ account.id }>
                                        <Td>
                                            <Link to={ `/account/${account.id}` }>
                                                <AccountAvatar
                                                    account={ account }
                                                    role={ false }
                                                    size="xs"
                                                />
                                            </Link>
                                        </Td>
                                        <Td>{ account.email }</Td>

                                        <Td isNumeric>{ formatDateTime(account.createdAt) }</Td>
                                        <Td isNumeric>
                                            <Menu>
                                                <MenuButton
                                                    px={ 2 }
                                                    py={ 0.5 }
                                                    transition="all 0.2s"
                                                    _focus={ { boxShadow: "outline" } }
                                                >
                                                    <MdSettings />
                                                </MenuButton>
                                                <MenuList>
                                                    <MenuItem
                                                        onClick={ () => handleDeleteEvent(account.id) }
                                                    >
                                                        Fshi
                                                    </MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                    </Tr>
                                )) }
                            </Tbody>
                        </Table>
                    </Box>
                ) }
            </>
        </>
    );
};

export default Authors;
